import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const reverse = (source) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 1: {
            const generator = () => {
                return dataFunc.generator().reverse();
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
        case 2: {
            const generator = async () => {
                const array = await dataFunc.generator();
                return array.reverse();
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
        case 0: {
            const generator = async () => {
                const array = await dataFunc.generator();
                return array.reverse();
            };
            return new BasicParallelEnumerable({
                generator,
                type: dataFunc.type,
            });
        }
    }
};
